'use strict';

import _ from 'lodash'
import Vue, {PluginObject} from 'vue';
import axios from 'axios'
import Axios from 'axios'

/**
 * Determinar la URL base de la API de Artisan en función de la configuración.
 *
 * @return { string }
 */
export function getHost (): string {
    // La URL configurada en localstorage['configServer'] tiene la prioridad mas alta
    return localStorage.getItem('config.server')
        // Si no existe URL configurada de forma local se tomará del entorno
        || process.env.VUE_APP_API_URL
        // Por último, si no se ha podido determinar la URL se presupone que la app
        // se encuentra en el mismo domino que el servicio
        || `${window.location.protocol}//${window.location.hostname}/api/v1`
}

const config = {
    baseURL: getHost(),
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
};

const _axios = axios.create(config);
_axios.interceptors.request.use(
    (config) => {
        // Do something before request is sent
        return config;
    },
    (error) => {
        // Do something with request error
        return Promise.reject(error);
    },
);

// Add a response interceptor
_axios.interceptors.response.use(
    (response) => {
        // Do something with response data
        return response;
    },
    (error: Error) => {
        error.message = _.get(error, 'response.data.message', error.message)

        // Do something with response error
        return Promise.reject(error);
    },
);

const Plugin: PluginObject<any> = {
    install () {
        Object.defineProperties(Vue.prototype, {
            axios: {
                get () {
                    return _axios;
                },
            },
            $axios: {
                get () {
                    return _axios;
                },
            },
        });
    },
}

Vue.use(Plugin)

export {_axios as axios}
export default Plugin;
